import { __decorate } from "tslib";
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import Drawer from '@blade/common/components/task-management/paint.vue';
import { MapPolygonsModule } from '@blade-sxp/task-management/store/mapPolygons';
import { cloneDeep } from 'lodash';
import mapUtil from '@blade-sxp/map/components/index.vue';
let MapDarwer = class MapDarwer extends Vue {
    zoneId;
    zoneListLinkedStaffLeave;
    buttons;
    showSelect;
    limits;
    isPlayFlag;
    directionConfig;
    specifiedStyle;
    paintState;
    options;
    activeTask;
    personList;
    deviceList;
    backgroundURL;
    mapConfig;
    mapType;
    mode;
    loading;
    roiDisabled;
    styleProp;
    mapSource;
    index;
    videoPolygons;
    mapId;
    showPoints;
    isDragPerson = false;
    // loading:boolean = true;
    zoneListLinked = [];
    localpaintState = true;
    showBottomText = false;
    mapReturn = true;
    isLoading = false;
    progress = 0;
    get mainAngle() {
        try {
            let mapConfig = JSON.parse(this.mapConfig);
            return JSON.parse(mapConfig?.configJson);
        }
        catch (e) {
            return null;
        }
    }
    onChangeMapSource(val) {
        this.zoneListLinked = val;
    }
    get setBoxStyle() {
        return {
            width: `${this.styleProp.width}px`,
            height: `${this.styleProp.height}px`,
        };
    }
    onStart() {
        this.progress = 0;
        this.isLoading = true;
    }
    onEnd() {
        this.isLoading = false;
    }
    onError(err) {
        this.isLoading = false;
        console.log(err);
    }
    onProgress(progress) {
        this.progress = Number((parseInt(String((progress.loaded / progress.total) * 1000)) / 10).toFixed(2));
    }
    formatPolygons(val) {
        const dom = document.querySelector('.map');
        let mapDom = this.$refs.mapEnd;
        const rectInfor = dom.getBoundingClientRect();
        const offSetLeft = rectInfor.left;
        const offSetTop = rectInfor.top;
        let verticesLocal = [];
        const h = this.styleProp.height;
        const w = this.styleProp.width;
        if (h && w && val) {
            cloneDeep(val).forEach((item) => {
                verticesLocal = item.vertices.map((item) => {
                    const { relativePosition } = mapDom?.clientToMapPosition(Number(item.x) * w + offSetLeft, Number(item.y) * h + offSetTop) || {};
                    return {
                        x: relativePosition?.x,
                        y: relativePosition?.y,
                        z: 0,
                    };
                });
            });
        }
        return verticesLocal;
    }
    getMapdrawend(val) {
        if (val && val.length) {
            const mapLen = val[0].vertices.length;
            const videoLen = this.videoPolygons[0].vertices.length;
            const id = val[0].id;
            if (mapLen !== videoLen && id) {
                this.$message.error(this.$t('mapRoiError').toString());
                this.$emit('drawend', '');
                const darwerDom = this.$refs.simpleDrawer;
                this.$nextTick(() => {
                    darwerDom.deleteGraph(id);
                });
            }
            else {
                this.$message({
                    message: `ROI-${this.index + 1} complete`,
                    type: 'success',
                });
                if (this.mapType === '3D-Three.js') {
                    const dom = this.$refs.mapEnd;
                    const datalist = [];
                    val?.forEach((item) => {
                        // id = item.id;
                        item.vertices?.forEach((vertice) => {
                            vertice.x = vertice.x * 2 - 1;
                            vertice.y = 1 - vertice.y * 2;
                            const itemData = {
                                ...dom.getWorldPosition(vertice),
                            };
                            datalist.push(itemData);
                        });
                    });
                    const zoneListLinked = [
                        {
                            vertices: datalist,
                            id: this.mapId,
                            type: 'roi3d',
                        },
                    ];
                    this.$emit('drawend', zoneListLinked);
                }
                else if (this.mapType === '2D') {
                    const data = this.formatPolygons(val);
                    const zoneListLinked = [
                        {
                            vertices: data,
                            title: 'roi-01',
                        },
                    ];
                    this.$emit('drawend', zoneListLinked);
                }
                const darwerDom = this.$refs.simpleDrawer;
                this.$nextTick(() => {
                    darwerDom.deleteGraph(id);
                });
            }
        }
        this.$emit('change-mode');
    }
    get mouseBgClass() {
        let polygonPoints = MapPolygonsModule.currPolygonPoints;
        if (!this.showPoints || !this.paintState)
            return '';
        if (this.paintState) {
            const videoLen = this.videoPolygons[0].vertices.length; // 需要确认是否只会有一个roi
            if (polygonPoints === videoLen - 1)
                return 'mouse-bg-finish';
            return `mouse-bg-${polygonPoints + 1}`;
        }
    }
    onClickMap(target, targets, position) {
        this.drawPersonPosition(position);
    }
    drawPersonPosition(position) {
        let relativePosition;
        if (this.mapType === '3D-Three.js') {
            relativePosition = position?.worldPosition;
        }
        else if (this.mapType === '2D') {
            relativePosition = position?.relativePosition;
        }
        this.$emit('drawPersonPosition', relativePosition);
    }
    loadedMap() {
        this.$nextTick(() => {
            this.mapReturn = false;
        });
    }
    mounted() { }
};
__decorate([
    Prop()
], MapDarwer.prototype, "zoneId", void 0);
__decorate([
    Prop()
], MapDarwer.prototype, "zoneListLinkedStaffLeave", void 0);
__decorate([
    Prop()
], MapDarwer.prototype, "buttons", void 0);
__decorate([
    Prop({ default: true })
], MapDarwer.prototype, "showSelect", void 0);
__decorate([
    Prop()
], MapDarwer.prototype, "limits", void 0);
__decorate([
    Prop()
], MapDarwer.prototype, "isPlayFlag", void 0);
__decorate([
    Prop()
], MapDarwer.prototype, "directionConfig", void 0);
__decorate([
    Prop()
], MapDarwer.prototype, "specifiedStyle", void 0);
__decorate([
    Prop()
], MapDarwer.prototype, "paintState", void 0);
__decorate([
    Prop()
], MapDarwer.prototype, "options", void 0);
__decorate([
    Prop()
], MapDarwer.prototype, "activeTask", void 0);
__decorate([
    Prop()
], MapDarwer.prototype, "personList", void 0);
__decorate([
    Prop()
], MapDarwer.prototype, "deviceList", void 0);
__decorate([
    Prop()
], MapDarwer.prototype, "backgroundURL", void 0);
__decorate([
    Prop()
], MapDarwer.prototype, "mapConfig", void 0);
__decorate([
    Prop()
], MapDarwer.prototype, "mapType", void 0);
__decorate([
    Prop()
], MapDarwer.prototype, "mode", void 0);
__decorate([
    Prop({ default: true })
], MapDarwer.prototype, "loading", void 0);
__decorate([
    Prop({ default: false, type: Boolean })
], MapDarwer.prototype, "roiDisabled", void 0);
__decorate([
    Prop({
        type: Object,
        default: () => {
            return {
                width: 738,
                height: 415,
            };
        },
    })
], MapDarwer.prototype, "styleProp", void 0);
__decorate([
    Prop()
], MapDarwer.prototype, "mapSource", void 0);
__decorate([
    Prop()
], MapDarwer.prototype, "index", void 0);
__decorate([
    Prop()
], MapDarwer.prototype, "videoPolygons", void 0);
__decorate([
    Prop()
], MapDarwer.prototype, "mapId", void 0);
__decorate([
    Prop()
], MapDarwer.prototype, "showPoints", void 0);
__decorate([
    Prop()
], MapDarwer.prototype, "isDragPerson", void 0);
__decorate([
    Watch('mapSource', { immediate: true, deep: true })
], MapDarwer.prototype, "onChangeMapSource", null);
MapDarwer = __decorate([
    Component({
        name: 'MapDarwer',
        components: {
            'st-drawer': Drawer,
            'st-map': mapUtil,
        },
        i18n: {
            messages: {
                en: {
                    mapRoiError: 'The number of sides of the ROI on the map must be the same as that of the corresponding ROI in the video',
                },
                zh: {
                    mapRoiError: '地图上ROI的边数必须和视频中对应ROI的边数相同',
                },
            },
        },
    })
], MapDarwer);
export default MapDarwer;
